<template>
  <div class="about-statistics">
    <div class="list-template" v-for="data in title" :key="data.title">
      <p>{{data.title}}</p>
      <p v-text="data.content"></p>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
    };
  },
  name:'aboutStatistics',
  props:{
      title:Array
  }
};
</script>
<style lang='scss' scoped>
.about-statistics {
  .list-template {
    p {
      &:nth-child(1) {
        padding: 0.2rem;
        color: #f9b014;
      }
      &:nth-child(2) {
        color: #999999;
        padding: 0.2rem;
      }
    }
    width: 94%;
    margin: 0 auto;
    margin-bottom: 0.2rem;
    background: #fff;
    border-radius: 0.1rem;
  }
  font-size: 0.3rem;
}
</style>